// use-life-os-seeds.ts — one-time, idempotent seeds run once per mount.
// Extracted from useLifeOs.ts. Both sweeps use deterministic ids so they are
// safe before remote sync merges and converge across devices via the same ids.

import { useEffect, useRef } from "react";
import type { LifeOsActions } from "../lib/life-os-contract";

export function useLifeOsSeeds(actions: LifeOsActions) {
  // D27/D31: sweep recurring tasks once on load.
  const recurringSwept = useRef(false);
  useEffect(() => {
    if (recurringSwept.current) {
      return;
    }
    recurringSwept.current = true;
    actions.generateRecurringTasks();
  }, [actions]);

  // D43: seed standard finance categories when empty — once per mount.
  const financeCategoriesSeeded = useRef(false);
  useEffect(() => {
    if (financeCategoriesSeeded.current) {
      return;
    }
    financeCategoriesSeeded.current = true;
    actions.seedDefaultFinanceCategories();
  }, [actions]);
}
